import useDataFetching from "hooks/useDataFetching";
import { config } from "variables/config";
import MuiTable from "components/MuiTable";
import MButton from "components/Mbutton";
import { useNavigate } from "react-router-dom";
import { getZoneHeader } from "Constaints"; // Importer la fonction traduite
import { BsList, BsPlusCircle } from "react-icons/bs";
import AddZone from "./AddZone";
import { useState } from "react";
import AddZoneEnterprise from "./AddZoneEnterprise";
import { useTranslation } from "react-i18next"; // Importer useTranslation

export default function Zones() {
    const navigate = useNavigate();
    const { t } = useTranslation("zones_list"); // Utiliser le namespace 'zonesList'
    const [selectedZone, setSelectedZone] = useState(null);

    const handleClick = (item) => {
        setSelectedZone(item);
    };

    const [loading, errorE, zones, fetchDataE] = useDataFetching(
        `${config.app.api_url}/zones`
    );

    const [open, setOpen] = useState(false);
    const [openE, setOpenE] = useState(false);

    function createData(N, nom, description, departement, region, actions) {
        return {
            N, nom, description, departement, region, actions
        };
    }

    const rows = zones?.data?.map((item, index) => {
        return {
            datas: createData(
                index + 1,
                `${t("zone")} ${item?.number || '--'}`, // Traduit
                item?.description,
                item?.department?.name,
                item?.department?.region?.name,
                <div className="flex flex-col gap-2">
                    <MButton
                        onClick={() => navigate("/admin/enterprises", { state: { zone: item } })}
                    >
                        <BsList/>
                        {t("its_enterprises")} {/* Traduit */}
                    </MButton>
                    <MButton
                        onClick={() => { setSelectedZone(item); setOpenE(true); }}
                    >
                        <BsPlusCircle />
                        {t("assign_enterprise")} {/* Traduit */}
                    </MButton>
                </div>
            ),
        };
    });

    return (
        <>
            <AddZone endFetch={fetchDataE} isOpen={open} onClose={() => setOpen(false)} />
            <AddZoneEnterprise endFetch={fetchDataE} zone={selectedZone} isOpen={openE} onClose={() => setOpenE(false)} />

            <div className="flex justify-end my-2">
                <MButton variant={"primary"}
                    onClick={() => { setOpen(true); }}
                >
                    <BsPlusCircle /> {t("create_zone")} {/* Traduit */}
                </MButton>
            </div>
            <MuiTable
                loading={loading}
                hidePagiation={true}
                columns={getZoneHeader(t)}
                rows={rows}
                textEmpty={t("no_zones")} /> {/* Traduit */}
        </>
    );
}